<section class="section-main-padding">
    <h1 class="page-title">Our Gallery</h1>
    <div class="video-section">
        <div class="video-container">
            <div class="main-video-wrapper" [@videoState]="videoState">
                <video [src]="selectedVideo.videoUrl" controls autoplay class="main-video"></video>
                <div class="video-info" [@fadeIn]>
                    <h2 class="video-title">{{ selectedVideo.title }}</h2>
                    <p class="video-description">{{ selectedVideo.description }}</p>
                </div>
            </div>

            <div class="playlist-container">
                <h3 class="playlist-title">More Videos</h3>
                <div class="playlist-wrapper">
                    <div *ngFor="let video of videosArr; let i = index" class="playlist-item"
                        [class.active]="isVideoActive(i)" (click)="playVideo(video, i)" [@fadeIn]>
                        <div class="thumbnail-wrapper">
                            <img [src]="video.thumbnailUrl" [alt]="video.title" class="thumbnail-img">
                            <div class="play-overlay">
                                <span class="play-icon">▶</span>
                            </div>
                        </div>
                        <div class="item-info">
                            <h4 class="item-title">{{ video.title }}</h4>
                            <p class="item-description">{{ video.description }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>